import hostMap from './hostMap';

function createCancelable(fn) {
	return function cancelableEffect(...args) {
		return fn(...args);
	};
}

/**
 * Take the latest effect and cancel any previously started effect fns
 *
 * Currently only supports generator fns
 *
 * @param host
 * @param actionType
 * @param effectFn
 * @returns {R|*}
 */
export default function takeLatest(host, actionType, effectFn) {
	if (!hostMap.has(host)) hostMap.set(host, new WeakMap());

	const effectMap = hostMap.get(host);

	if (!effectMap.has(effectFn)) effectMap.set(effectFn, {});

	const actionMappings = effectMap.get(effectFn);
	if (actionMappings[actionType]) actionMappings[actionType].cancelled = true;

	actionMappings[actionType] = createCancelable(effectFn);

	return actionMappings[actionType];
}
